var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-tooltip",
    {
      attrs: {
        top: "",
        offset: 4,
        "nudge-right": "5",
        "content-class": "custom-tooltip",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-icon",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "info-icon",
                      attrs: {
                        color: "primary",
                        "aria-label": "More information",
                      },
                    },
                    "v-icon",
                    attrs,
                    false
                  ),
                  on
                ),
                [_vm._v("\n      mdi-information\n    ")]
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("span", [
        _c("b", [_vm._v(" " + _vm._s(_vm.textInitial) + " ")]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.listItems, function (item, index) {
            return _c("li", { key: index }, [
              _vm._v("\n        " + _vm._s(item) + "\n      "),
            ])
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }